module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "dedicationPage",
    attrs: {
      "id": "dedicationpage"
    }
  }, [_c('a', {
    attrs: {
      "id": "page05"
    }
  }, [_c('p', {
    staticClass: "dedicationText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("To every client, every audience member,"), _c('br'), _vm._v(" everyone who’s ever read my books,"), _c('br'), _vm._v(" everyone who’s ever touched my life along the way—"), _c('br'), _vm._v("you’ve contributed more to this book"), _c('br'), _vm._v(" and to the journey of my soul"), _c('br'), _vm._v(" than I can ever repay.")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page05"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-028ef5a4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/003dedicationpage.vue
// module id = 63
// module chunks = 0